var O = /* @__PURE__ */ ((r) => (r.DESKTOP = "desktop", r.MOBILE = "mobile", r))(O || {}), E = /* @__PURE__ */ ((r) => (r.LOGGED = "1", r.LOGGED_OUT = "2", r))(E || {});
export {
  O as SitePlatform,
  E as UserLoginStatus
};
